import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { AppI18nProvider } from '../i18n';
import { AuthServicesProvider } from '../modules/auth/ui/auth-services-context';
import { authServices } from './auth-services';
import { AuthStateProvider } from './auth-state-provider';
import { queryClient } from './query-client';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <AppI18nProvider>
      <QueryClientProvider client={queryClient}>
        <AuthServicesProvider services={authServices}>
          <AuthStateProvider>{children}</AuthStateProvider>
        </AuthServicesProvider>
      </QueryClientProvider>
    </AppI18nProvider>
  );
}
